import { getCups } from '../../functions/getCups';
import trackToString from '../../functions/trackToString';
import DisplayCups from '../../components/DisplayCups';
import { useLayoutEffect, useState } from 'react';
import CupDisplay from '../../components/track-components/CupDisplay';
import cupToString from '../../functions/cupToString';
import CupBuilderHeader from '../../../shared/components/CupBuilderHeader/CupBuilderHeader';
import CupComplete from '../../../shared/components/CupComplete/CupComplete';
import SmallPop from '../../../shared/components/pops/SmallPop';

import "./CupBuilder.css";
import { useLocation, useOutletContext } from 'react-router-dom';
// import getRandomTrack from '../../functions/getRandomTrack';

export default function CupBuilder() {

    const [width] = useOutletContext();
    const location = useLocation();

    const cups = getCups();
    const [shownCup, setShownCup] = useState("mushroom");

    // track data for user's cup, use loader if signing in/up after building a cup
    const [yourCup, setYourCup] = useState(location.state?.yourCup ? location.state.yourCup
        : [null, null, null, null]);

    const [smallPop, setSmallPop] = useState(location.state?.deletingAccount ?
        { text: "Account deleted." } : null);

    useLayoutEffect(() => {

        const timeout = setTimeout(() => {
            setSmallPop(false);
        }, 3500);

        return () => clearTimeout(timeout);

    }, [smallPop]);

    /**
     * Adds a track object to the user's cup.
     * @param {*} track - a number from a selected track or a Track object
     */
    const addTrack = (track) => {
        const newCup = [...yourCup];
        const addTrack = typeof track === "number" ?
            cups.get(shownCup).tracks[track] : track;
        addTrack.origin ??= null;

        if (newCup.indexOf(null) !== -1 /* &&  !hasTrack(yourCup, addTrack) */ ) {
            newCup[newCup.indexOf(null)] = {
                ...addTrack,
                cup: shownCup,
                emblem: cups.get(shownCup).emblem,
                originIndex: track,
                origin: !addTrack.origin ? null : addTrack?.origin
            };
            setYourCup([...newCup]);

            if (newCup.indexOf(null) === -1) {
                window.scrollTo(0, 0);
            }
        } else {
            setSmallPop({ text: "You have already selected this track." });
        }
    }

    /**
     * Checks if a given cup array has a track in it already.
     * @param {Array} cup - an array of cup objects
     * @param {Object} track - a track object 
     * @returns if the passed cup has the passed track in it or not.
     */
    // const hasTrack = (cup, track) => {
    //     for (let i = 0; i < yourCup.length; i++) {
    //         if (cup[i]?.name === track.name && cup[i].origin === track.origin) {
    //             return true;
    //         }
    //     }
    //     return false;
    // }

    /**
     * Removes the last selected track from the user's cup.
     */
    const undo = () => {
        const goBack = yourCup.indexOf(null);
        const newCup = [...yourCup];
        newCup[goBack - 1] = null;
        setYourCup(newCup);
    }

    /**
     * Resets the user's cup back to empty.
     */
    const reset = () => {
        setYourCup([null, null, null, null]);
    }

    /**
     * Formats cup data for Firestore storage.
     */
    const formatCupForFirestore = (cup, cupName) => {
        // check if cup has any booster course pass tracks
        const hasDLC = (tracks) => {
            for (const track in tracks) {
                if (isDLC(tracks[track].cup)) {
                    return true;
                }
            }
            return false;
        }

        // returns if track is DLC for query purposes
        const isDLC = (cup) => {
            return cup === "golden-dash" || cup === "lucky-cat" || cup === "turnip" || cup === "propeller"
                || cup === "rock" || cup === "moon" || cup === "fruit" || cup === "boomerang"
                || cup === "feather" || cup === "cherry" || cup === "acorn" || cup === "spiny";
        }

        // actual firestore datapoints, track info saved locally (getTrackData() converts
        // this information to visual track information. (functions folder) )
        const tracks = [
            { cup: cup[0].cup, originIndex: cup[0].originIndex },
            { cup: cup[1].cup, originIndex: cup[1].originIndex },
            { cup: cup[2].cup, originIndex: cup[2].originIndex },
            { cup: cup[3].cup, originIndex: cup[3].originIndex }
        ];

        // track names if i query by name eventually
        const trackList = [...cup.map((element) => { return trackToString(element) })];

        return {
            containsDLC: hasDLC(cup),
            tracks: tracks,
            trackList: trackList
        };
    };

    return <div id="main-container">
        <div
            id="track-maker"
            className='track-modal'
            style={{ display: yourCup.indexOf(null) >= 0 ? "flex" : "none" }}
        >

            <CupBuilderHeader
                onUndo={undo}
                onReset={reset}
                currentTrackNumber={yourCup.indexOf(null) + 1}
                totalTracks={yourCup.length}
                isDisabled={yourCup.every(track => track === null)}
                variant="mk8dx"
            />

            <div>
                <h3>Your Custom Cup</h3>
                <CupDisplay
                    tracks={yourCup}
                    variant="your-cup"
                    selectedIndex={yourCup.indexOf(null)}
                />
            </div>

            <DisplayCups
                cups={cups}
                shownCup={shownCup}
                setShownCup={setShownCup}
                width={width}
            />

            <div>
                <h3>{cups.get(shownCup).display} Cup</h3>
                <CupDisplay
                    tracks={cups.get(shownCup).tracks}
                    variant="selection"
                    onTrackClick={addTrack}
                />
            </div>

        </div>

        <div
            id="cup-complete"
            className='track-modal'
            style={{ display: yourCup.indexOf(null) === -1 ? "flex" : "none" }}
        >
            <CupComplete
                cup={yourCup}
                cupDisplay={(cupName, setCupName) => (
                    <div id='cup-container'>
                        <CupDisplay
                            tracks={yourCup}
                            variant="browse"
                            showEmblems={true}
                            editable={true}
                            cupName={cupName}
                            onNameChange={setCupName}
                        />
                    </div>
                )}
                onReset={() => {
                    reset();
                    setShownCup("mushroom");
                }}
                formatCupForFirestore={formatCupForFirestore}
                formatCupText={cupToString}
                firestoreCollection="cups"
                userCupsField="cups"
                gameLabel="#MK8DX"
                shareUrl="https://mk8dx-cup-builder.web.app/mk8dx"
                defaultImageName="Your Cup"
                signInState={{ yourCup: yourCup }}
                variant="mk8dx"
            />
        </div>

        {
            smallPop &&
            <SmallPop
                text={smallPop.text}
                link={smallPop.link}
                onclose={() => setSmallPop(null)}
            />
        }
    </div>
}